var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.552.351a1.2 1.2 0 0 1 1.697 0l8.4 8.4a1.2 1.2 0 0 1 0 1.697l-8.4 8.4a1.2 1.2 0 1 1-1.697-1.697l6.35-6.351H1.2a1.2 1.2 0 0 1 0-2.4h18.703l-6.351-6.351a1.2 1.2 0 0 1 0-1.698",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;